/* Hannovae: keeps "Coming soon" on the add to cart button of products tagged coming-soon, also after a size is picked. */
(function () {
  if (!window.customElements) return;
  customElements.whenDefined('product-variants').then(function () {
    var C = customElements.get('product-variants');
    if (!C || C.prototype.hnvComingSoonPatched) return;
    var original = C.prototype.updateBuyButtons;
    if (typeof original !== 'function') return;
    C.prototype.updateBuyButtons = function () {
      original.apply(this, arguments);
      var t = this.addToCartText;
      if (t && t.hasAttribute('data-coming-soon') && (!this.currentVariant || !this.currentVariant.available)) {
        t.textContent = t.getAttribute('data-coming-soon');
      }
    };
    C.prototype.hnvComingSoonPatched = true;
  });
})();